import templateUrl from './payroll-analysis-summary-compact-table.component.html';

export const PayrollAnalysisSummaryCompactTableComponent = {
    templateUrl,
    bindings: {
        payrollAnalysisSummary: "<",
        noShowFilters: "<"
    },
    controllerAs: "vm"
};

